import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiQaroniEnv } from '@qaroni-core/conf/apis/api-qaroni.config';
import { LoginDTO } from '../types/authentication';
import { OAuthResponse } from '../types/o-auth.response';

@Injectable({
  providedIn: 'root',
})
export class OAuthHttpService {
  private http = inject(HttpClient);

  public login$(loginDTO: LoginDTO) {
    const url = `${ApiQaroniEnv.URLBase}/auth/login`;

    return this.http.post<OAuthResponse>(url, loginDTO);
  }
}
